var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mt-1"},[_c('copyright')],1)}
var staticRenderFns = []

export { render, staticRenderFns }